import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Render app immediately for best FCP/LCP
createRoot(document.getElementById("root")!).render(<App />);

// Lazy load Sentry with very low priority - only after page is fully interactive
const loadSentry = () => {
  // On mobile, wait even longer to avoid blocking main thread
  const isMobile = window.innerWidth < 768;
  const delay = isMobile ? 12000 : 8000; // 12s mobile, 8s desktop - after critical content
  
  setTimeout(() => {
    import("@sentry/react").then((Sentry) => {
      Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
          }),
        ],
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0.01,
        replaysOnErrorSampleRate: 0.5,
        environment: import.meta.env.MODE,
        enabled: !!import.meta.env.VITE_SENTRY_DSN,
        beforeSend(event) {
          if (event.level === 'info' || event.level === 'log') {
            return null;
          }
          return event;
        },
      });
    }).catch(() => {
      // Silently fail if Sentry can't load
    });
  }, delay);
};

// Load Sentry with lowest priority after page load
window.addEventListener('load', () => {
  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(loadSentry, { timeout: 10000 });
  } else {
    loadSentry();
  }
});
